import { css } from '@/styled-system/css';

export const highlightsContainer = css({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 'tighter',
});
